<div class="loading-container" [class.hidden]="!isLoading">
  <div class="loading" [style.width]="size" [style.height]="size"></div>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵr.html